/* global $ I18n */
$(document).on('ready turbolinks:load', () => {
  $('[data-toggle="tooltip"]').tooltip({
    container: 'body',
  });
});
